"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMessageCircle01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 11.5a9.5 9.5 0 1 1 6.086 8.868 9.85 9.85 0 0 0-.183-.07l-.012-.004h-.004a6.868 6.868 0 0 0-.158.016l-5.155.533a7.31 7.31 0 0 1-.624.047c-.186.002-.52-.008-.842-.204a1.5 1.5 0 0 1-.7-1.048c-.059-.372.06-.685.133-.856.073-.172.18-.37.282-.559l1.652-3.057c.072-.133.11-.204.136-.257l.003-.008A9.49 9.49 0 0 1 3 11.5Z", fill: "currentColor" }) }))); };
exports.default = SvgMessageCircle01;
